<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconClass" />
  </svg>
</template>

<script>
export default {
  props: {
    //  使用icon的图标类型
    type: {
      type: String,
      required: true
    },
    // 是否添加class样式
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconClass() {
      return `#icon-${this.type}`;
    },
    svgClass() {
      if (this.className) {
        return `icon ${this.className}`;
      } else {
        return 'icon';
      }
    }
  }
};
</script>

<style type="text/css" scoped>
.icon {
  width: 1em;
  height: 1em;
  overflow: hidden;
  font-size: 16px;
}
</style>
